module.exports = __webpack_public_path__ + "static/media/eng_d_2344.a8184caf.vtt";